import {getAssetPath} from "../../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const USER_IMAGE = getAssetPath("img/user.png");
export const NO_IMAGE = getAssetPath("img/no-img.png");

export const getBackgroundImage = (event) => {
    if (!event) return USER_IMAGE;

    if (event?.imagePath) return `${API_KEEPER}${event.imagePath}`;
    if (event?.individualId) return `${API_KEEPER}/individual-monitoring/image/${event.individualId}`;

    return USER_IMAGE;
};

export const getIndividualImageUrl = (individualId) => `${API_KEEPER}/individual-monitoring/image/${individualId}`;

export const getPassageImageUrl = (imagePath) => `${API_KEEPER}${imagePath}`;

export const errMessageI18n = (message) => {
    const i18n = {
        "initial.date.missing": "O campo Data/hora inicial é obrigatório",
        "final.date.missing": "O campo Data/hora final é obrigatório",
        "threshold.invalid": "\"Confiança da leitura\" inválida.",
        "individual.with.cpf.not.found": "CPF não encontrado.",
        "facegateway.image.type.unsupported": "Tipo de arquivo inválido. Envie apenas arquivos JPEG.",
        "facegateway.image.does.not.have.human.face": "Rosto humano não detectado na imagem.",
        "facegateway.camera.id.is.required": "Não há câmeras cadastradas no sistema de reconhecimento facial."
    };

    return i18n[message] ?? "Não foi possível realizar a pesquisa.";
};
